import React from 'react';
import { FlexElement } from './flex.styles.js';
export const Flex = React.forwardRef(({ elementType = 'div', ...rest }, ref) => (React.createElement(FlexElement, { as: elementType, ref: ref, ...rest })));
//# sourceMappingURL=flex.component.js.map